import { render, staticRenderFns } from "./AddCNICRegistrar.vue?vue&type=template&id=63f5076c"
import script from "./AddCNICRegistrar.vue?vue&type=script&lang=js"
export * from "./AddCNICRegistrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports